import { ListenableSubscribable } from '@benzinga/subscribable';
import { Geo } from './entities';

const GEO_STORAGE_KEY = 'geo-data';

const TWENTY_FOUR_HOURS = 86400 * 1000;

interface StoredGeoData {
  geoLocation: Geo;
  timestamp: number;
}

interface GeoStoreEvent {
  type: 'geo_store:updated';
  geoLocation: Geo;
}

export class GeoStore extends ListenableSubscribable<GeoStoreEvent> {
  private geoData?: StoredGeoData;

  constructor() {
    super();
    this.loadFromLocalStorage();
  }

  public shouldFetchGeoLocation = (): boolean => {
    if (!this.geoData) {
      return true;
    }

    const now = Date.now();
    const dataAge = now - this.geoData.timestamp;

    return dataAge > TWENTY_FOUR_HOURS;
  };

  public getGeoLocation = (): Geo | undefined => {
    return this.geoData?.geoLocation;
  };

  public setGeoLocation = (geoLocation: Geo): void => {
    this.geoData = {
      geoLocation,
      timestamp: Date.now(),
    };

    try {
      if (this.geoData) {
        localStorage.setItem(GEO_STORAGE_KEY, JSON.stringify(this.geoData));
        this.dispatch({
          geoLocation,
          type: 'geo_store:updated',
        });
      }
    } catch (error) {
      console.error('Error saving geo data to localStorage:', error);
    }
  };

  private loadFromLocalStorage = (): void => {
    try {
      const storedData = localStorage.getItem(GEO_STORAGE_KEY);
      if (storedData) {
        this.geoData = JSON.parse(storedData) as StoredGeoData;
      }
    } catch (error) {
      console.error('Error loading geo data from localStorage:', error);
    }
  };
}
